import Vue from "vue/dist/vue.esm";
import 'es6-promise/auto';


import TextualMenu from "./library/js/components/menu/textual-menu.vue";
import Loader from "./library/js/components/loader.vue";
import TextInput from "./library/js/components/material-form/text-input.vue";
import PeppermillDialog from "./library/js/components/peppermill/PeppermillDialog.vue";
import TextualMenuStore from "./library/js/store/textual-menu.store";

Vue.component('textual-menu', TextualMenu);
Vue.component('loader', Loader);
Vue.component('text-input', TextInput);
Vue.component('peppermill-dialog', PeppermillDialog);

new Vue({
  store: TextualMenuStore
})
    .$mount("#container");